import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet } from '_zari/core'

import { IdGen } from 'utils'

import * as AsientoContableCrud from 'services/asientosContables.service'

import MainForm from './mainForm'

const NuevoxPlantillaPage = ({ match, location }) => {
  const __zariContext = React.useContext(ZariContext)

  const [_mainFormKey, setMainFormKey] = React.useState(null)
  const [editData, setEditData] = React.useState({})

  React.useEffect(() => {
    if (match.params.id) {
      AsientoContableCrud.getAsEdicion2(match.params.id)
        .then(({ data }) => {
          setEditData(data)
          setMainFormKey(IdGen.newId())
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
        })
    } else {
      setMainFormKey(IdGen.newId())
    }
  }, [match.params.id, __zariContext])

  const resetMainForm = React.useCallback(() => {
    setEditData({})
    setMainFormKey(IdGen.newId())
  }, [])

  return (
    <>
      <Portlet>
        <Portlet.Header title='Presupuestos' />
        <Portlet.Body>{_mainFormKey && <MainForm key={_mainFormKey} editData={editData} resetMainForm={resetMainForm} />}</Portlet.Body>
      </Portlet>
    </>
  )
}

export default React.memo(NuevoxPlantillaPage)
